import { useRef } from "react"
import ReactTextareaAutocomplete from "@webscopeio/react-textarea-autocomplete"
import { useGetSlackUsernamesQuery } from "@apis/users/useUsers"

const Item = ({ entity: { name }, selected }) => {
  if (selected) {
    return (
      <div
        className="autocomplete-select"
        style={{ backgroundColor: "#F5F5F5" }}
      >
        <b>@{name}</b>
      </div>
    )
  }
  return (
    <div className="autocomplete-select">
      <b>@{name}</b>
    </div>
  )
}

const AutoComplete = ({ value, onChange }) => {
  const getSlackUsernamesQuery = useGetSlackUsernamesQuery()
  const rtaRef = useRef()

  return (
    <ReactTextareaAutocomplete
      className="form-control mb-2 w-100"
      listStyle={{
        listStyleType: "none",
        padding: 0,
      }}
      loadingComponent={() => <span>Loading</span>}
      placeholder={getSlackUsernamesQuery.isError ? "Add note. Error fetching slack users." : "@slackUsername to ping teammate"}
      ref={rtaRef}
      trigger={{
        "@": {
          dataProvider: (input) => {
            return getSlackUsernamesQuery.data?.filter((u) => u.label.includes(input))
              .map((user) => {
                return { name: user.label }
              })
          },
          component: Item,
          output: (item, trigger) => `${trigger}${item.name}`,
        },
      }}
      value={value}
      onChange={(e) => onChange(e)}
    />
  )
}

export default AutoComplete
